import { cartPageContainerStyles } from "@insite/content-library/Widgets/Cart/CartPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

cartPageContainerStyles.container = {
    css: css`
        /* stylelint-disable value-no-vendor-prefix */
        display: -ms-grid;
        display: grid;
        overflow: hidden;
        h1 {
            color: #3666b1;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        grid-template-columns: minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 1fr);
                    `,
                    null,
                    css`
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        -ms-grid-columns: minmax(0, 1fr) minmax(0, 1fr);
                        grid-template-rows: repeat(5, auto);
                        -ms-grid-rows: auto auto auto auto auto;
                    `,
                    css`
                        grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 2fr) minmax(0, 1fr);
                    `,
                ],
                "min",
            )}
        section[id^="cartHeader"] {
            > section {
                > div:last-child[class^="HiddenStyle"] {
                    margin-bottom: 20px;
                    > button[data-test-selector^="cartlineHeader_removeAll"] {
                        float: right;
                    }
                }
            }
        }
        div[data-test-selector^="productCarousel_crossSells"] {
            > div[class^="GridOffset"] {
                > div:first-child[class^="GridItemStyle"] {
                    flex-basis: 4%;
                    max-width: 4%;
                }
                > div[class^="GridItemStyle"] {
                    &:nth-child(2) {
                        flex-basis: 92%;
                        max-width: 92%;
                    }
                }
                > div:last-child[class^="GridItemStyle"] {
                    flex-basis: 4%;
                    max-width: 4%;
                }
            }
        }
    `,
};

cartPageContainerStyles.cartLinesContainer = {
    css: css`
        [data-test-selector="productImage"] {
            height: 150px;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                object-position: center top;
            }
        }
        [data-test-selector="productDescriptionLink"] {
            span {
                color: rgb(15, 15, 15);
                font-weight: 700;
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        border: 0 solid transparent;
                        border-width: 0 1.5rem 1.5rem 0;
                    `,
                    null,
                    css`
                        grid-column-start: 1;
                        -ms-grid-column: 1;
                        grid-row-start: 2;
                        -ms-grid-row: 2;
                        grid-row-end: 6;
                        -ms-grid-row-span: 6;
                    `,
                ],
                "min",
            )}
    `,
};
